<script lang="ts">
    import { getOperation } from "../../../../api"
    import { openOverlay } from "../../../../store"
    import { tooltip } from "../../../../helper"
    import { _ } from "svelte-i18n"
    import Icon from "../../../widgets/Icon.svelte"
    import { mdiTag } from "@mdi/js"

    import DateField from "../../../widgets/fields/DateField.svelte"
    import StatusField from "../../../widgets/fields/StatusField.svelte"
    import MiniLoader from "../../../widgets/MiniLoader.svelte"
    import TextField from "./fields/TextField.svelte"
    import OperationAddress from "./fields/OperationAddress.svelte"
    import SourceField from "../../../widgets/fields/SourceField.svelte"

    export let operation: OperationOut

    const getReferenceOperation = async () => {
        if (operation.refNumber) {
            const response = await getOperation("operation", {
                number: operation.refNumber,
            })
            if (Array.isArray(response.data) && response?.data?.length) {
                return response.data[0]
            }
        }
    }

    const getOperationOutOfferReference = async () => {
        if (operation?.operationOutOfferReference?.number) {
            const response = await getOperation("operation-out", {
                number: operation.operationOutOfferReference?.number,
                dealerNumber: operation.dealerNumber,
            })
            if (Array.isArray(response.data) && response?.data?.length) {
                return response.data[0]
            }
        }
    }
</script>

<div class="overlay_table1">
    <div class="table tableview responsive_table_overlay">
        <div class="tablerow trow column1">
            <div class="col w-80 aligncenter">
                <span class="title">{$_("operations.head.origin")}</span>
                <SourceField
                    value="{operation.source}"
                    additionalInfo="{operation.source == 10 && operation.clerk?.name
                        ? '(SB: ' + operation.clerk.name + ')'
                        : ''}"
                />
            </div>
            <div class="col w-80">
                <span class="title">{$_("operations.head.customerNumber")}</span>
                <span class="content">{operation.dealerNumber}</span>
            </div>
            <div class="col w-150">
                <span class="title"
                    >{@html operation.type == 1
                        ? $_("operations.head.offerDate")
                        : $_("operations.head.orderConfirmationDate")}</span
                >
                <span class="content"><DateField value="{operation.insertTime}" /></span>
            </div>
            <div class="col mw-100 w-100">
                <span class="title"
                    >{operation.type == 1 ? $_("operations.head.offerNr") : $_("operations.head.orderNr")}</span
                >
                <span class="content">{operation.number}</span>
            </div>

            <div class="col mw-100 w-100">
                <span class="title">{$_("operations.head.source")}</span>
                {#await getReferenceOperation()}
                    <div class="mt-sm">
                        <MiniLoader />
                    </div>
                {:then refOp}
                    {#if refOp}
                        <a
                            href="{null}"
                            class="content pointer layout layout-gap-xs align-items-center"
                            on:click="{() => openOverlay(refOp)}"
                            use:tooltip="{{
                                content:
                                    operation.type == 1
                                        ? $_('operations.head.openOriginalOffer')
                                        : $_('operations.head.openOriginalOrder'),
                            }}"
                        >
                            <Icon path="{mdiTag}" />{refOp.number}
                        </a>
                    {/if}
                {/await}
            </div>
            {#if operation.type == 2 && !!operation?.operationOutOfferReference?.number}
                <div class="col mw-100 w-100">
                    <span class="title">{$_("operations.head.source")}<br />({$_("operations.head.initialOffer")})</span
                    >
                    {#await getOperationOutOfferReference()}
                        <div class="mt-sm">
                            <MiniLoader />
                        </div>
                    {:then refOp}
                        {#if refOp}
                            <a
                                href="{null}"
                                class="content pointer layout layout-gap-xs align-items-center"
                                on:click="{() => openOverlay(refOp)}"
                                use:tooltip="{{
                                    content: $_('operations.head.openOriginalOffer'),
                                }}"
                            >
                                <Icon path="{mdiTag}" />{refOp.number}
                            </a>
                        {:else}
                            <div style="max-width: 100%;">{$_("operations.head.noReferenceFound")}</div>
                        {/if}
                    {/await}
                </div>
            {/if}
            <div class="col mw-80 w-80 aligncenter">
                <span class="title">{$_("operations.head.amountOfPositions")}</span>
                <span class="content"
                    >{operation.countOfPositions
                        ? operation.type == 1
                            ? operation.countOfPositions - (operation.countOfCanceledPositions || 0)
                            : operation.countOfPositions
                        : ""}</span
                >
            </div>
        </div>

        <div class="tablerow trow column2">
            <div class="col status mw-70 w-70">
                <span class="title">{$_("operations.head.status")}</span>
                <StatusField row="{operation}" />
            </div>
            <div class="col">
                <span class="title">{$_("operations.head.inquiryDate")}</span>
                <span class="content"><DateField value="{operation.inquiryDate}" /></span>
            </div>
            {#if operation.collectionName == "operation-out"}
                <div class="col w-170">
                    <span class="title">{@html $_("operations.head.editedLast")}</span>
                    <span class="content">{operation.lastUpdatedBy?.name || ""}</span>
                </div>
            {:else}
                <div class="col w-170">
                    <span class="title">{$_("operations.head.clerk")}</span>
                    <span class="content">{operation.inquiryContact?.name || ""}</span>
                </div>
            {/if}
        </div>

        <div class="tablerow trow column3"></div>
    </div>
</div>
{#if !operation.statusSummary?.emailed}
    <div class="edit-header-data">
        <div class="row">
            <div class="col-lg-4 col-md-12">
                <OperationAddress bind:operation />
            </div>

            <div class="col-lg-2 col-md-6">
                <TextField
                    label="{$_('general.email')}"
                    value="{operation.endCustomerEmail}"
                    maxlength="{56}"
                    on:blur="{(e) => {
                        operation.endCustomerEmail = e.detail
                        if (operation.endCustomerFullAddress) {
                            operation.endCustomerFullAddress.contact.email = e.detail
                        }
                    }}"
                />
            </div>
            <div class="col-lg-2 col-md-6">
                <TextField
                    label="{$_('operations.head.yourReference')}"
                    maxlength="{20}"
                    value="{operation.customReference || ''}"
                    on:blur="{(e) => {
                        operation.customReference = e.detail
                    }}"
                />
            </div>
            <div class="col-lg-2 col-md-6">
                <TextField
                    label="{$_('operations.head.constructionProject')}"
                    value="{operation.constructionProject}"
                    cssClass="last"
                    maxlength="{30}"
                    on:blur="{(e) => {
                        operation.constructionProject = e.detail
                    }}"
                />
            </div>
            <div class="col-lg-2 col-md-6">
                <TextField
                    label="{$_('operations.head.commission')}"
                    maxlength="{30}"
                    value="{operation.commission}"
                    cssClass="last"
                    on:blur="{(e) => (operation.commission = e.detail)}"
                />
            </div>
        </div>
    </div>
{/if}
